import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type PixelKPINameType =
  | 'pixel-total-impressions'
  | 'pixel-efficiency'
  | 'pixel-reached-companies'
  | 'pixel-engaged-companies'
  | 'pixel-pipeline-influenced'
  | 'pixel-closed-won-influenced';

export const pixelGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<PixelKPINameType>[]>
> => ({
  pixel: [
    { value: 'pixel-total-impressions', label: t`Total Impressions`, allowsAudience: false },
    {
      value: 'pixel-efficiency',
      label: t`Audience Pixel Efficiency`,
      allowsAudience: false,
    },
    { value: 'pixel-reached-companies', label: t`Reached Companies`, allowsAudience: false },
    { value: 'pixel-engaged-companies', label: t`Engaged Companies`, allowsAudience: false },
    {
      value: 'pixel-pipeline-influenced',
      label: t`Pipeline Influence`,
      allowsAudience: false,
    },
    {
      value: 'pixel-closed-won-influenced',
      label: t`Closed Won Influence`,
      allowsAudience: false,
    },
  ],
});
